module.exports = __webpack_public_path__ + "static/media/TCL-logo.45dcc179.png";